import React, { useContext, useEffect, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Icon, Table } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { CoolFarmOptionsContext } from '../..'

interface Props {
  id: string
  energyIndex: number
  removeEnergyType: (energyIndex: number) => void
}

const EnergyType:React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { control, formState: { touchedFields }, setValue } = useFormContext()
  const { id, energyIndex, removeEnergyType } = props
  const options = useContext(CoolFarmOptionsContext)

  const watchEnergyId = useWatch({ control, name: `energyTypes.${energyIndex}.id` })
  const [units, setUnits] = useState([])

  useEffect(() => {
    if(touchedFields?.energyTypes && touchedFields?.energyTypes[energyIndex]?.id){
      setValue(`energyTypes.${energyIndex}.amountUnit`, '')
    }
    const energy = options?.energyTypes.find(energy => energy.id === watchEnergyId)
    if(energy) {
      setUnits(energy.units || [])
    }
  }, [watchEnergyId, energyIndex])

  const energyTypeOptions = options?.energyTypes?.map(energy => ({
    key: energy.id,
    value: energy.id,
    text: energy.label
  })) || []

  return <>
    <Table.Row key={id}>
      <Table.Cell>
        <FormFields.Select
          control={control}
          search
          name={`energyTypes.${energyIndex}.id`}
          options={energyTypeOptions}
          placeholder={t('Select energy type')}
          rules={{ required: t('Required') }}
          withoutLabel
          noErrorMessage
                />
      </Table.Cell>
      <Table.Cell>
        <FormFields.Input
          control={control}
          name={`energyTypes.${energyIndex}.amount`}
          placeholder={t('Amount')}
          rules={{ required: t('Required') }}
          typeInput='controled'
          allowDecimals
          decimalScale={2}
          withoutAsterisk
          noErrorMessage
                />
      </Table.Cell>
      <Table.Cell>
        <FormFields.Select
          control={control}
          name={`energyTypes.${energyIndex}.amountUnit`}
          options={units.map(unit => ({ value: unit.key, text: unit.label }))}
          placeholder={t('Unit')}
          rules={{ required: t('Required') }}
          withoutLabel
          noErrorMessage
                />
      </Table.Cell>
      <Table.Cell textAlign='center'>
        <Icon
          name='trash'
          color='red'
          style={{ cursor: 'pointer' }}
          onClick={() => removeEnergyType(energyIndex)}
                />
      </Table.Cell>
    </Table.Row>
  </>
}
export default EnergyType